<template>
	<AppDialog :dialogName="'Tutorials'" width="800" max-width="800">
		<div class="guided-tutorials-chapter-list-dialog">
			<div class="dialog-title">Tutorial</div>

			<div class="dialog-description">{{ title }}</div>

			<div class="dialog-body">
				<div
					v-for="(chapter, index) in chapters"
					:key="chapter.start_time"
					class="chapter-section flex-space-between--center hover-transition"
				>
					<div class="left-side">
						<div class="font-size-sm font-weight-600 mb-1">Step {{ index }}</div>
						<div class="font-size-md">{{ chapter.title }}</div>
						<div class="font-size-sm subtle-message">{{ chapter.description }}</div>
					</div>
					<div class="right-side flex-centerize link-style" @click="playChapter(index)">
						<div class="white-space-nowrap mr-3">Play Step</div>
						<SmallPlaySvg />
					</div>
				</div>
			</div>

			<div class="dialog-bottom"></div>
		</div>
	</AppDialog>
</template>

<script>
import AppDialog from '@/components/dialogs/AppDialog/AppDialog.vue';
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';

import SmallPlaySvg from './assets/SmallPlaySvg';

export default {
	name: 'GuidedTutorialsChapterListDialog',
	components: {
		AppDialog,
		SmallPlaySvg,
	},
	props: {
		chapters: { type: Array },
		title: { type: String },
		playChapterCallback: { type: Function },
		dialogPromiseHandlers: { type: Object },
	},
	computed: {},
	methods: {
		close() {
			this.dialogPromiseHandlers.resolve();
			AppDialogManagerService.closeCurrentDialog();
		},
		playChapter(index) {
			this.playChapterCallback(index);
			this.close();
		},
	},
};
</script>

<style scoped lang="scss">
.guided-tutorials-chapter-list-dialog {
	.dialog-title {
		padding-bottom: 0 !important;
		font-size: 12px !important;
		font-weight: 300 !important;
	}
	.dialog-description {
		margin-bottom: 30px;
		font-size: 20px !important;
		font-weight: 700;
	}
	.chapter-section {
		margin: 0 -15px 8px -15px;
		padding: 10px;
		background-color: #fbfbfc;
		border-radius: 7px;

		.left-side {
			padding-right: 6px;
		}
		.right-side {
			color: #5b5be6 !important;
		}

		&:hover {
			background-color: #f5f5f9;

			.right-side {
				transform: scale(1.08);
			}
		}
	}
}
</style>
